import React from "react";

export const userNotes = [
    {id: 1, note: 'User given free ticket', date: '4pm, 13th September 2020', author: 'Prath Kaneri', authorId: 2}
];
